import * as Common from "../../commons/common"

export class SheetBase {
  grade: number = null
  name: string = ""
  curriculum_id: string = ""
  subject_name: string = ""
  exec_date: string = ""
  created_by: string = null
  browse_lock: boolean = false
  edit_lock: boolean = false
  is_sort_answer_image_enable: boolean = true
  is_print_view_point: boolean = false
  is_print_part1: boolean = false
  digital_answer_type: number
  is_linked_students: boolean = false
  is_self_scoring_enable: boolean = false
  is_disp_correct_question_image: boolean = false
  subject_code: string = ""
}

export class Examinee{
  room_name: string | null
  student_no: number | null
  student_no_character: string
  student_name: string
  email: string
  is_uploaded: boolean = false
  

  constructor(examinee: any){
    this.room_name = examinee.room_name;
    this.student_no = examinee.student_no == undefined ? null : examinee.student_no;
    this.student_no_character = examinee.student_no_character == undefined ? null : examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.email = examinee.email;
  }
}

export class Curriculum {
  id: number
  name: string
  constructor(curriculum: any){
    this.id = curriculum.id;
    this.name = curriculum.name;
  }
}

export class Condition{
  grade: string = ""
  month: string = ""
  sheet_group_key: string = ""
  curriculum_id: string = ""
  subject_code: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
  is_digital_paper: boolean = true
}

export class Sheet {
  grade: string
  name: string
  curriculum_id: string
  subject_name: string
  subject_code: string
  exec_date: string
  edit_lock: boolean
  browse_lock: boolean
  is_sort_answer_image_enable: boolean
  is_print_view_point: boolean
  is_print_part1: boolean
  digital_answer_type: number
  sheet_group_key: number
  is_self_scoring_enable: boolean
  is_disp_correct_question_image: boolean
  sheet_type: number

  constructor(x: any){
    this.grade = x.grade;
    this.name = x.name;
    this.curriculum_id = x.curriculum_id;
    this.subject_name = x.subject_name;
    this.subject_code = x.subject_code;
    this.exec_date = x.exec_date;
    this.edit_lock = x.edit_lock;
    this.browse_lock = x.browse_lock;
    this.is_sort_answer_image_enable = x.is_sort_answer_image_enable
    this.is_print_view_point = x.is_print_view_point;
    this.is_print_part1 = x.is_print_part1;
    this.digital_answer_type = x.digital_answer_type;
    this.sheet_group_key = x.sheet_group_key;
    this.is_self_scoring_enable = x.is_self_scoring_enable;
    this.is_disp_correct_question_image = x.is_disp_correct_question_image;
    this.sheet_type = x.sheet_type;
  }
}

export class Student {
  id: number
  student_no_character: string
  grade: number
  room_name: string
  student_no: number
  student_name: string
  email: string
  is_selected: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.student_no_character = x.student_no_character;
    this.grade = x.grade;
    this.room_name = x.room_name;
    this.student_no = x.student_no;
    this.student_name = x.student_name;
    this.email = x.email;
    this.is_selected = x.is_selected != null ? x.is_selected : this.is_selected;
  }
}

export class User {
  id: number
  login_id: string
  name: string
  curriculum_id: number[]
  subject_codes: string[]
  role: string
  is_selected: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.login_id = x.login_id;
    this.name = x.name;
    this.curriculum_id = !x.curriculum_id ? [] : x.curriculum_id.split(",").map((y: string) => Number(y));
    this.subject_codes = x.subject_codes;
    this.role = x.role;
  }
}

export interface SheetGroup {
  room_name: string
  student_count: string
  is_uploaded: boolean
  student_no_characters: string[]
  students: Student[]
}